import { render, staticRenderFns } from "./SideFloatingWindow.vue?vue&type=template&id=1ded9afb&scoped=true&"
import script from "./SideFloatingWindow.vue?vue&type=script&lang=js&"
export * from "./SideFloatingWindow.vue?vue&type=script&lang=js&"
import style0 from "./SideFloatingWindow.vue?vue&type=style&index=0&id=1ded9afb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded9afb",
  null
  
)

export default component.exports